import { Modal } from 'antd';
import { t } from 'i18next';
import React from 'react';

interface RevertModalProps {
  isOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
  isLoading: boolean;
  version: string;
  modalText: string;
  setModalText: React.Dispatch<React.SetStateAction<string>>;
}

export const RevertToVersionModal: React.FC<RevertModalProps> = ({
  isOpen,
  onOk,
  onCancel,
  isLoading,
  version,
  modalText,
  setModalText,
}) => {
  const handleOk = () => {
    if (modalText) {
      onCancel();
      setModalText('');
    } else {
      onOk();
    }
  };
  const handleCancel = () => {
    onCancel();
    setModalText('');
  };

  return (
    <Modal
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={t('ok')}
      cancelText={t('cancel')}
      cancelButtonProps={modalText ? { style: { display: 'none' } } : null}
      confirmLoading={!modalText && isLoading}
      centered
      title={!modalText ? t('Revert to Previous Version') : undefined}
      maskClosable={true}
      closable={true}
      maskTransitionName=""
      transitionName=""
    >
      <span>
        {!modalText
          ? t('revertConfirmation', {
              version,
            })
          : modalText}
      </span>
    </Modal>
  );
};
